window.ShopifyTheme = window.ShopifyTheme || {};
window.ShopifyEventBus = new EventTarget();
window.ShopifyTheme.cartAbortController = null; // Global race-condition tracker
ShopifyTheme.sideCarDrawer = (open) => {
  if(open) {
    document.body.classList.add('overflow-hidden');
    document.querySelector('.side-cart-js')?.classList.remove('hide');
  }
  else {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.side-cart-js')?.classList.add('hide');
  }
}
ShopifyTheme.rerenderCart = async(obj) => {
  const sectionId = obj?.sectionId || 'cart-section'; 
  const targetSelector = obj?.targetSelector || '.cart-section-js'; 
  
  let parent_item = "",item_key=""; 
  const targetElement = obj.targetElement || null;
  if(targetElement) parent_item = targetElement.closest('[data-key]');
  if(parent_item) item_key = parent_item.getAttribute('data-key');
  
  try {
    const response = await fetch(`${window.location.pathname}?sections=${sectionId}`);
    const responseData = await response.json();
    
    const htmlParser = new DOMParser();
    const parsedHTML = htmlParser.parseFromString(responseData[sectionId], 'text/html');
    
    const newCartContent = parsedHTML.querySelector(`${targetSelector}`);
    const currentCartContent = document.querySelector(`${targetSelector}`);

    if (currentCartContent && newCartContent) {
      currentCartContent.innerHTML = newCartContent.innerHTML;
      const message = obj.message || null;
      if(item_key && message) {
        let rendered_parent_item = "",errorEle = "";
        rendered_parent_item = currentCartContent.querySelector(`[data-key = "${item_key}"]`);
        if(rendered_parent_item) errorEle = rendered_parent_item?.querySelector('.error-js');
        if(errorEle) {
          errorEle.innerText = message;
          errorEle.classList.remove('hide');
          setTimeout(() => {
             errorEle.classList.add('hide');
            errorEle.innerText = '';
          },3000)
        } 
      }
      console.log('Cart re-rendered successfully.',targetElement);
      document.querySelector('.cart-overlay-js')?.classList.add('hide')
    }
    else {
      document.querySelector('.cart-overlay-js')?.classList.add('hide')
    }
  } catch (error) {
    console.error('Failed to re-render cart section:', error);
    document.querySelector('.cart-overlay-js')?.classList.add('hide')
  }
}
ShopifyTheme.renderCartHTML = function(obj) {
  let htmlString = obj.htmlString || null;
  let targetSelector = obj.targetSelector || '.cart-section-js';
  if (!htmlString) return;

  try {
    const htmlParser = new DOMParser();
    const parsedHTML = htmlParser.parseFromString(htmlString, 'text/html');
    
    const newCartContent = parsedHTML.querySelector(targetSelector);
    const currentCartContent = document.querySelector(targetSelector);

    if (currentCartContent && newCartContent) {
      currentCartContent.innerHTML = newCartContent.innerHTML;
      console.log(`[Global Utility]: DOM Re-rendered successfully for ${targetSelector}`);
    } else {
      console.warn(`[Global Utility]: Target container ${targetSelector} not found in current DOM or response.`);
    }
  } catch (error) {
    console.error('[Global Utility]: HTML parsing failed:', error);
  }
};
ShopifyTheme.addToCart = async function(obj) {
  const variantId = obj.variantId || null;
  const quantity = obj.quantity || 1;
  const openSideCart = obj?.openSideCart || true;
  const sectionId = obj.sectionId || 'cart-section';
  if (!variantId) return;
  // RACE CONDITION GUARD: Abort ongoing requests instantly to prevent 3s server choke
  if (window.ShopifyTheme.cartAbortController) {
    window.ShopifyTheme.cartAbortController.abort();
  }
  window.ShopifyTheme.cartAbortController = new AbortController();
  const { signal } = window.ShopifyTheme.cartAbortController;

   try {
    const rootPath = window.Shopify.routes.root || '/';
    const response = await fetch(`${rootPath}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: signal,
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: sectionId
      })
    });

    if (response.status == 200) {
      const responseData = await response.json();
      const sectionHtml = responseData.sections ? responseData.sections[sectionId] : null;
      if (sectionHtml) {
        obj.htmlString=sectionHtml
        ShopifyTheme.renderCartHTML(obj);
        if(openSideCart) ShopifyTheme.sideCarDrawer(true);
      }
      document.querySelector('.cart-overlay-js')?.classList.add('hide')
    }
    if (response.status == 200) return;
    
    let responseData = await response.json();
    if(!responseData) document.querySelector('.cart-overlay-js')?.classList.add('hide');
    ShopifyTheme.rerenderCart(obj);
    // document.querySelector('.cart-overlay-js')?.classList.add('hide')
    if (response.status != 200) throw new Error('Network response not ok');
  } catch (error) {
    if (error.name === 'AbortError') return; // Silent catch for user multi-clicks
    console.error('[Global Cart Engine]: addition failed:', error);
    // document.querySelector('.cart-overlay-js')?.classList.add('hide')
  }
}
ShopifyTheme.updateQuantity = async function(obj) {
  const lineKey = obj.lineKey || null;
  // Checking explicitly against undefined/null because '0' is a valid target quantity
  const quantity = (obj.quantity !== undefined && obj.quantity !== null) ? obj.quantity : null;
  const sectionId = obj.sectionId || 'cart-section';
  const openSideCart = obj?.openSideCart || true;
  const target = obj.targetElement || null;
  let block_item = target?.closest('[data-block-item]');

  
  if (!lineKey || quantity === null) return;

  // RACE CONDITION GUARD: Abort ongoing requests instantly to prevent 3s server choke
  if (window.ShopifyTheme.cartAbortController) {
    window.ShopifyTheme.cartAbortController.abort();
  }
  window.ShopifyTheme.cartAbortController = new AbortController();
  const { signal } = window.ShopifyTheme.cartAbortController;

  try {
    const rootPath = window.Shopify.routes.root || '/';
    const response = await fetch(`${rootPath}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: signal,
      body: JSON.stringify({
        line: lineKey,
        quantity: Number(quantity),
        sections: sectionId
      })
    });
    if (response.status == 200) {
      const responseData = await response.json();
      const sectionHtml = responseData.sections ? responseData.sections[sectionId] : null;
    
      if (sectionHtml) {
        obj.htmlString = sectionHtml
        ShopifyTheme.renderCartHTML(obj);
        if(openSideCart) ShopifyTheme.sideCarDrawer(true);
      }
      document.querySelector('.cart-overlay-js')?.classList.add('hide')
    }
    if (response.status == 200) return;

    let responseData = await response.json();
    if(!responseData) document.querySelector('.cart-overlay-js')?.classList.add('hide');
    let message = responseData && responseData.message ? responseData.message  : null;
    obj.message = message || null;
    // let error = block_item?.querySelector('.error-js');
    // if(error) {
    //   error.innerText = responseData?.message;
    //   setTimeout(() => {
    //     error.innerText = '';
    //   },3000)
    // }
    ShopifyTheme.rerenderCart(obj);
    if (response.status != 200) throw new Error('Network response not ok');
    
  } catch (error) {
    if (error.name === 'AbortError') return; // Silent catch for user multi-clicks
    console.error('[Global Cart Engine]: Update failed:', error);
    // ShopifyTheme.rerenderCart(obj);
    // document.querySelector('.cart-overlay-js')?.classList.add('hide')
    // UI ROLLBACK MECHANISM: Triggered if network fails
    if (obj.targetElement && obj.rollbackQty !== null) {
      const itemRow = obj.targetElement.closest('[data-key]');
      const input = itemRow ? itemRow.querySelector('[data-qty-input]') : null;
      if (input) input.value = obj.rollbackQty;
      if (itemRow) itemRow.style.opacity = '1';
    }
  }
};

// Isolated Centralized Event Router
ShopifyEventBus.addEventListener('shopify:cart:add', (event) => {
  const eventData = event.detail;
  if (!eventData) return;
  ShopifyTheme.addToCart(eventData);
});
// Isolated Centralized Event Router
ShopifyEventBus.addEventListener('shopify:cart:change', (event) => {
  const eventData = event.detail;
  if (!eventData) return;
  ShopifyTheme.updateQuantity(eventData);
});